import {
  GET_ORG_WALLET_REQUESTS_START,
  GET_ORG_WALLET_REQUESTS_SUCCESS,
  GET_ORG_WALLET_REQUESTS_ERROR,
} from 'constants/action-types/wallets/getOrgRequests';

export default (state, { type, payload }) => {
  switch (type) {
    case GET_ORG_WALLET_REQUESTS_START:
      return {
        ...state,
        topupOrgRequests: {
          ...state.topupOrgRequests,
          loading: true,
          error: null,
          items: [],
          meta: null,
        },
      };
    case GET_ORG_WALLET_REQUESTS_ERROR:
      return {
        ...state,
        topupOrgRequests: {
          ...state.topupOrgRequests,
          error: payload,
          loading: false,
          items: [],
          meta: null,
        },
      };
    case GET_ORG_WALLET_REQUESTS_SUCCESS:
      return {
        ...state,
        topupOrgRequests: {
          ...state.topupOrgRequests,
          loading: false,
          error: null,
          items: payload.data,
          meta: payload.meta,
        },
      };
    default:
      return null;
  }
};
